var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"container-newspage"},[_c('v-alert',{attrs:{"border":"left","type":"info"}},[_vm._v(" No news were found ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }